import React, { useEffect, useState } from 'react'
import domToReact from 'html-react-parser/lib/dom-to-react'
import useScript from 'react-script-hook'
import LockedPinpoll from './components/LockedPinpoll'
import getPinpollId from './modules/get-pinpoll-id'

const ExternalPinpoll = (attribs, embedBoxChildren) => {
  const [loading, error] = useScript({
    src: 'https://tools.pinpoll.com/global.js',
    checkForExisting: true,
  })
  const [pinpollId, setPinpollId] = useState()
  const isPinpollReady = !loading && !error

  useEffect(() => {
    if (!loading && !error && window && window.Pinpoll && !!window.Pinpoll.embed) {
      window.Pinpoll.embed.start()
    }
  }, [loading, error])

  useEffect(() => {
    const pinpollId = getPinpollId({ element: embedBoxChildren })
    setPinpollId(pinpollId)
  }, [isPinpollReady])

  return (
    <>
      {false && <LockedPinpoll ready={isPinpollReady} pinpollId={pinpollId} />}
      <div id={'pinpollParentNode'}>{domToReact(embedBoxChildren)}</div>
    </>
  )
}

export default ExternalPinpoll
